import { useContext } from 'react';
import { OrderContext } from './OrdersPage';

const EMPTY_ORDER_CONTEXT = {
  orders: [],
  setOrders: () => {},
  setOrderUpdated: () => {},
  orderUpdated: false,
};

/**
 * Order list context when embedded inside OrdersPage; safe no-op fallback elsewhere
 * (e.g. OrderDetailModal opened from QuoteTable).
 *
 * @returns {{ orders: Array, setOrders: Function, setOrderUpdated: Function, orderUpdated: boolean }}
 */
const useOptionalOrderContext = () => {
  const context = useContext(OrderContext);
  if (
    !context ||
    typeof context.setOrders !== 'function' ||
    !Array.isArray(context.orders)
  ) {
    return EMPTY_ORDER_CONTEXT;
  }
  return context;
};

export default useOptionalOrderContext;
